import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Bolt0_list$Bolt0 from "./bolt0_list.bs.js";

function pass(msg, alist) {
  Curry._1(Printf.printf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["[\xe2\x9c\x94] ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* Char_literal */
  Block.__(12, [
  /* "\n" */
  10,
  /* End_of_format */
  0])])]), "[\xe2\x9c\x94] %s\n"]), msg);

  return Bolt0_list$Bolt0.iter(function (param) {
    return Curry._2(Printf.printf(
    /* Format */
    [
    /* String */
    Block.__(2, [
    /* No_padding */
    0,
    /* String_literal */
    Block.__(11, [": ",
    /* String */
    Block.__(2, [
    /* No_padding */
    0,
    /* Char_literal */
    Block.__(12, [
    /* "\n" */
    10,
    /* End_of_format */
    0])])])]), "%s: %s\n"]), param[0], param[1]);
  }, alist);
}

function fail(msg, alist) {
  Curry._1(Printf.printf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["[\xe2\x9d\x8c] ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* Char_literal */
  Block.__(12, [
  /* "\n" */
  10,
  /* End_of_format */
  0])])]), "[\xe2\x9d\x8c] %s\n"]), msg);

  return Bolt0_list$Bolt0.iter(function (param) {
    return Curry._2(Printf.printf(
    /* Format */
    [
    /* String */
    Block.__(2, [
    /* No_padding */
    0,
    /* String_literal */
    Block.__(11, [": ",
    /* String */
    Block.__(2, [
    /* No_padding */
    0,
    /* Char_literal */
    Block.__(12, [
    /* "\n" */
    10,
    /* End_of_format */
    0])])])]), "%s: %s\n"]), param[0], param[1]);
  }, alist);
}

export { pass, fail };
/* No side effect */